import { render, staticRenderFns } from "./search-result-type-video.vue?vue&type=template&id=6a1bfcec&scoped=true&"
import script from "./search-result-type-video.vue?vue&type=script&lang=js&"
export * from "./search-result-type-video.vue?vue&type=script&lang=js&"
import style0 from "./search-result-type-video.vue?vue&type=style&index=0&id=6a1bfcec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1bfcec",
  null
  
)

export default component.exports